import moment from 'moment';

import WpToastManager from 'Wpds/components/toast/WpToastManager';
import { showNotificationError } from 'Shared/helpers';
import { dueDateTimeFormat } from 'Shared/utils/DateTime.utils';
import { getActionItems, getDiscussionTopics } from 'Shared/selectors/meetingItems';
import { handleRequestError } from 'Shared/utils/handle-request-error';
import { buildHomePageTasksSortOrder } from 'Shared/reducers/utils';
import { getHomePageV2Data, homePageTaskAssignedDrop } from 'Shared/api/HomePage.api';
import { NOON_TIME } from 'Shared/constants/constants';
import { ItemType } from 'Shared/constants/types';
import { createItemFromSourceItemAction } from 'Shared/actions/meetingItems';

export const getHomePageV2DataAction = ({ completed, getAll }) => async dispatch => {
  try {
    const response = await getHomePageV2Data({
      status: completed ? 'completed' : 'not_completed',
      all: getAll ? 'all' : undefined,
    });
    if (response && response.status === 200) {
      dispatch({ type: 'GET_MEETING_ITEMS_RESPONSE', payload: response.data });
    }
    return response;
  } catch (err) {
    showNotificationError(err);
    return err;
  }
};

export const clearCompletedHomePageDataAction = () => dispatch => dispatch({ type: 'CLEAR_COMPLETED_HOME_PAGE_DATA' });

export function homePageTaskAssignedDropAction({ draggedItemUuids, hoveredItemUuid, hoverOffset, itemsType }) {
  return (dispatch, getState) => {
    dispatch({
      type: 'HOME_PAGE_TASK_ASSIGNED_DROP_REQUEST',
      meetingItemType: itemsType,
      payload: { draggedItemUuids, hoveredItemUuid, hoverOffset },
    });
    const state = getState();
    const {
      app: { clientSyncToken },
    } = state;

    const data = {
      uuidsToPositions: JSON.stringify(
        buildHomePageTasksSortOrder(
          ItemType.actionItem === itemsType ? getActionItems(state) : getDiscussionTopics(state)
        )
      ),
      clientSyncToken,
    };

    return handleRequestError(homePageTaskAssignedDrop(data)).catch(error => {
      WpToastManager.danger(error.message);
    });
  };
}

export function createHomePageItemAction({ sourceItemUuid, itemUuid }) {
  return async dispatch => {
    const dueBy = dueDateTimeFormat(moment().add(7, 'days'), NOON_TIME);
    return dispatch(
      createItemFromSourceItemAction({ sourceItemUuid, itemUuid, positionField: 'positionForHomePage', dueBy })
    ).then(response => {
      dispatch(
        homePageTaskAssignedDropAction({
          draggedItemUuids: [itemUuid],
          hoveredItemUuid: sourceItemUuid,
          hoverOffset: 1,
          itemsType: response.data.itemType,
        })
      );
      return response;
    });
  };
}
